// Client-side age helpers mirroring the design's ageFromDob (circle-of-trust.dc.html) and the
// server's AgeCalculator. The server is authoritative; this drives live UX only.

/** Age in whole years from a yyyy-MM-dd string, or null for an invalid/future/impossible date. */
export function ageFromDob(dob: string | null | undefined): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dob || '')
  if (!m) return null
  const b = new Date(+m[1], +m[2] - 1, +m[3])
  if (isNaN(b.getTime()) || b > new Date()) return null
  const now = new Date()
  let a = now.getFullYear() - b.getFullYear()
  const md = now.getMonth() - b.getMonth()
  if (md < 0 || (md === 0 && now.getDate() < b.getDate())) a--
  return a < 0 || a > 120 ? null : a
}

/** en-GB short date ("25 Aug 2026") — matches the design's today(). */
export function todayEnGb(): string {
  return new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}
